module.exports = __webpack_public_path__ + "static/img/200146.1c565a9e.png";